import PropTypes from "prop-types"
import Section from "components/Layout/Section"
import * as css from "./StatCallout.module.css"

function StatCallout({ stat, statLabel, description, descriptionHtml }) {
  return (
    <Section padding="extraLight">
      <div className={css.card}>
        <div className={css.statBlock}>
          <p className={css.stat}>{stat}</p>
          {statLabel && <p className={css.statLabel}>{statLabel}</p>}
        </div>
        <div className={css.divider} aria-hidden="true" />
        {descriptionHtml ? (
          <div
            className={css.description}
            dangerouslySetInnerHTML={{ __html: descriptionHtml }}
          />
        ) : (
          description && <p className={css.description}>{description}</p>
        )}
      </div>
    </Section>
  )
}

StatCallout.propTypes = {
  stat: PropTypes.string.isRequired,
  statLabel: PropTypes.string,
  description: PropTypes.string,
  descriptionHtml: PropTypes.string,
}

export default StatCallout
